const Header = () => {
    
  return (
    <header>
      <h1>4 U 2 Write</h1>
    </header>
  );
};

export default Header;
